import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Header from '../components/Header'
import { useSelector } from 'react-redux';
import { handleGetSingleOrder } from '../../services/order';
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from "react-router-dom";


export const OrderSummary = () => {
    const [ order, setOrder ] = useState(null);
const navigate = useNavigate();
    // Order id 
    const { orderId } = useParams();
    // from redux
    const { authToken, userInfo } = useSelector((state) => state.user);

    const receiptRef = useRef()
    // TO print Receipt
    const handlePrint = useReactToPrint({
        content: () => receiptRef.current,
    });

    // Fetch order
    useEffect(() => {
    const fetchSingleOrder = async () => {
        try {
            const fetchedOrder = await handleGetSingleOrder(orderId, authToken);

            // Handle no data
            if (!fetchedOrder) {
                navigate("/order");
                return;
            }

            // Optional frontend check (just for UX, not security)
            if (fetchedOrder.user_id !== userInfo.id) {
                navigate("/order");
                return;
            }

            setOrder(fetchedOrder);

        } catch (error) {
            console.error(error);
            navigate("/order");
        }
    };

    fetchSingleOrder();
}, [orderId, authToken, userInfo]);

    // Format date helper function
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
        }) + ' ' + date.toLocaleTimeString('en-US', { 
            hour: '2-digit', 
            minute: '2-digit' 
        });
    };

    // Format delivery time
    const formatDeliveryTime = (deliveryTime) => {
        if (!deliveryTime) return '';
        const date = new Date(deliveryTime);
        return date.toLocaleTimeString('en-US', { 
            hour: '2-digit', 
            minute: '2-digit' 
        });
    };

    

    // Get delivery address based on address type
    const getDeliveryAddress = () => {
        if (!order?.order_delivery_address) return null;
        
        const address = order.order_delivery_address;
        const type = address.address_type;
        
        if (type === 'home') {
            return {
                name: address.name,
                type: 'Home',
                street: address.home_street_address,
                city: address.home_city,
                houseNo: address.home_house_no,
                directions: address.home_additional_directions,
                phone: address.phone
            };
        } else if (type === 'office') {
            return {
                name: address.name,
                type: 'Office',
                street: address.office_street_address,
                city: address.office_city,
                company: address.office_company,
                department: address.office_department,
                floor: address.office_floor,
                building: address.office_building_no,
                directions: address.office_additional_directions,
                phone: address.phone
            };
        } else if (type === 'apartment') {
            return {
                name: address.name,
                type: 'Apartment',
                street: address.apartment_street_address,
                city: address.apartment_city,
                apartmentName: address.apartment_name,
                apartmentNo: address.apartment_apartment_no,
                floor: address.apartment_floor,
                directions: address.apartment_directions,
                phone: address.phone
            };
        }
        
        return null;
    };

    // Show loading state
    if (!order) {
        return (
            <>
                <Header />
                <div className='container mx-auto'>
                    <div className="my-12">
                        <div className="text-center">Loading order details...</div>
                    </div>
                </div>
            </>
        );
    }

    const deliveryAddress = getDeliveryAddress();

    return (
        <>
            <Header />
            <div className='container mx-auto'>
                <div className="my-12">
                    <div className="border border-borderClr !rounded-xl p-6">
                        <div className="tracking-details p-relative text-center">
                            <h5 className="text-light-black fw-600">
                                {order.order_details && order.order_details.length > 0 ? order.order_details[0].name : 'Order'}
                            </h5>
                            <span className="text-light-white">Estimated Delivery time</span>
                            <h2 className="text-light-black fw-700 no-margin">
                                {order.delivery_slot || formatDeliveryTime(order.delivery_time)}
                            </h2>
                            <div id="add-listing-tab" className="step-app">
                                <ul className="step-steps">
                                    <li className={order.status === 'confirmed' || order.status === 'preparing' || order.status === 'delivering' || order.status === 'delivered' ? 'done' : ''}>
                                        <Link> <span className="number"></span>
                                            <span className="step-name">Order sent<br/>{formatDate(order.created_at).split(' ')[1]}</span>
                                        </Link>
                                    </li>
                                    <li className={order.status === 'preparing' ? 'active' : (order.status === 'delivering' || order.status === 'delivered') ? 'done' : ''}>
                                        <Link> <span className="number"></span>
                                            <span className="step-name">In the works</span>
                                        </Link>
                                    </li>
                                    <li className={order.status === 'delivering' ? 'active' : order.status === 'delivered' ? 'done' : ''}>
                                        <Link> <span className="number"></span>
                                            <span className="step-name">Out for delivery</span>
                                        </Link>
                                    </li>
                                    <li className={order.status === 'delivered' ? 'active' : ''}>
                                        <Link> <span className="number"></span>
                                            <span className="step-name">Delivered</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* Countdown timer - you may want to implement actual countdown logic based on delivery_time */}
                        <div className="mt-4">
                            <div className="recipt-name title full-width !justify-center">
                                <div className="countdown-box">
                                    <div className="time-box block">
                                        <span className='text-3xl font-bold'>01</span>
                                        <span className='text-xs mt-1 font-medium'>Hour</span>
                                    </div>
                                    <div className="time-box block">
                                        <span className='text-3xl font-bold'>05</span>
                                        <span className='text-xs mt-1 font-medium'>Minutes</span>
                                    </div>
                                    <div className="time-box block">
                                        <span className='text-3xl font-bold'>45</span>
                                        <span className='text-xs mt-1 font-medium'>Seconds</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- recipt --> */}
                    <div ref={receiptRef} className="recipt-sec padding-20 mt-4 !rounded-xl">
                        <div className="">
                            <div className="grid grid-cols-12 gap-6">
                                <div className="md:col-span-6 col-span-12">
                                    <div className="recipt-name full-width">
                                        <h5 className="mb-3 border-b border-primary border-dashed pb-2 font-semibold text-xl uppercase text-secondary tracking-widest">Delivery (ASAP) to:</h5>
                                        <span className="text-light-white ">{deliveryAddress?.name || order.name}</span>
                                        <span className="text-light-white ">{deliveryAddress?.type}</span>
                                        {deliveryAddress?.houseNo && <span className="text-light-white ">House: {deliveryAddress.houseNo}</span>}
                                        {deliveryAddress?.street && <span className="text-light-white ">{deliveryAddress.street}</span>}
                                        {deliveryAddress?.city && <span className="text-light-white ">{deliveryAddress.city}</span>}
                                        {deliveryAddress?.company && <span className="text-light-white ">{deliveryAddress.company}</span>}
                                        {deliveryAddress?.department && <span className="text-light-white ">{deliveryAddress.department}</span>}
                                        {deliveryAddress?.floor && <span className="text-light-white ">Floor: {deliveryAddress.floor}</span>}
                                        {deliveryAddress?.apartmentName && <span className="text-light-white ">{deliveryAddress.apartmentName}</span>}
                                        {deliveryAddress?.apartmentNo && <span className="text-light-white ">Apt: {deliveryAddress.apartmentNo}</span>}
                                        <p className="text-light-white ">{deliveryAddress?.phone || order.phone}</p>
                                    </div>
                                    <div className="recipt-name full-width padding-tb-10 pt-0">
                                        <h5 className="mb-3 border-b border-primary border-dashed pb-2 font-semibold text-xl uppercase text-secondary tracking-widest">Delivery instructions</h5>
                                        <p className="text-light-white ">
                                            {order.delivery_notes || 
                                             deliveryAddress?.directions || 
                                             order.order_delivery_address?.delivery_instruction || 
                                             'No special instructions'}
                                        </p>
                                    </div>
                                    {/* Subtotal Payment */}
                                    <div className="payment-method mb-md-40">
                                        <div className=''>
                                            <h3 className='mb-3 border-b border-primary border-dashed pb-2 font-semibold text-xl uppercase text-secondary tracking-widest'>Order Summary</h3>
                                            <div className='flex justify-between gap-2 mb-3'>
                                                <h3 className='text-lg font-bold mb-0'>Subtotal</h3>
                                                <h4 className='text-lg font-bold mb-0'>Rs. {Number(order.sub_total).toFixed(2)}</h4>
                                            </div>
                                            <div className='flex justify-between gap-2 mb-1'>
                                                <h3 className='text-lg font-medium mb-0'>Delivery Fee</h3>
                                                <h4 className='text-lg font-medium mb-0'>Rs. {Number(order.delivery_price).toFixed(2)}</h4>
                                            </div>
                                            <div className='flex justify-between gap-2 mb-1'>
                                                <h3 className='text-lg font-medium mb-0'>Service Fee</h3>
                                                <h4 className='text-lg font-medium mb-0'>Rs. {Number(order.service_fee).toFixed(2)}</h4>
                                            </div>
                                            <div className='flex justify-between gap-2 mb-1'>
                                                <h3 className='text-lg font-medium mb-0'>Shef Tip</h3>
                                                <h4 className='text-lg font-medium mb-0'>Rs. {Number(order.tip_price).toFixed(2)}</h4>
                                            </div>
                                            {order.discount_price > 0 && (
                                                <div className='flex justify-between gap-2 mb-1'>
                                                    <h3 className='text-lg font-medium mb-0'>Discount</h3>
                                                    <h4 className='text-lg font-medium mb-0 text-green-600'>-Rs. {Number(order.discount_price).toFixed(2)}</h4>
                                                </div>
                                            )}
                                            <div className='flex justify-between gap-2 mb-1 bg-primaryLight py-2 px-3 rounded-md'>
                                                <h3 className='text-lg font-bold mb-0'>Total</h3>
                                                <h4 className='text-lg font-bold mb-0'>Rs. {Number(order.total_price).toFixed(2)}</h4>
                                            </div>
                                            <div className='mt-2 text-sm text-light-white'>
                                                Payment Method: {order.payment_mode.charAt(0).toUpperCase() + order.payment_mode.slice(1)}
                                            </div>
                                        </div>
                                        <div className="mt-2"> 
                                            <Link className="btn-first white-btn fw-600 help-btn">Need Help?</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="md:col-span-6 col-span-12">
                                    <div className="col-lg-12">
                                        <h5 className="mb-3 border-b border-primary border-dashed pb-2 font-semibold text-xl uppercase text-secondary tracking-widest">
                                            Your Order 
                                            <span>
                                                <Link onClick={handlePrint} className="fs-12">Print receipt</Link>
                                            </span>
                                        </h5>
                                        <p className="title text-light-white">
                                            {formatDate(order.created_at)} <span className="text-light-black">Order #{order.order_code}</span>
                                        </p>
                                    </div>
                                    
                                    {/* Order Items */}
                                    {order.order_details && order.order_details.length > 0 && (
                                        <div className='bg-primaryLight p-4 rounded-lg mt-4'>
                                            <div className='flex items-center gap-x-2 bg-primaryLight p-2 rounded-lg'>
                                                <img 
                                                    src='/media/frontend/img/banner/female-chef.png' 
                                                    className='object-top rounded-full w-[30px] object-cover h-[30px]' 
                                                    alt='Chef' 
                                                />
                                                <Link to={`/shef-detail/${order.chef_id}`} className='!underline !text-secondary text-base font-semibold'>
                                                    Shef Profile
                                                </Link>
                                            </div>
                                            
                                            {/* Order Items */}
                                            {order.order_details.map((item, index) => (
                                                <div key={index} className='flex items-center justify-between border border-primary border-dashed rounded-lg p-2 gap-x-2 mt-4'>
                                                    <div className='flex items-center gap-x-2 w-[65%]'>
                                                        <img 
                                                            src='/media/frontend/img/restaurants/255x104/order-2.jpg' 
                                                            className='object-top rounded-lg w-[60px] object-cover h-[60px]' 
                                                            alt={item.name} 
                                                        />
                                                        <div>
                                                            <h3 className='mb-1 text-base font-semibold leading-tight'>{item.name}</h3>
                                                            <h4 className='text-lg font-semibold mb-0'>Rs. {Number(item.unit_price).toFixed(2)}</h4>
                                                        </div>
                                                    </div>
                                                    <div className='text-lg font-semibold pr-2'>x{item.quantity}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default OrderSummary